import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { navigateToSection } from "../../lib/sectionNavigation";
import { sectionLinks } from "../../lib/seo";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const socialLinks = [
    {
      icon: Instagram,
      href: "https://www.instagram.com/vinayak_enterpriseofficial?igsh=cmtvOTMzNDJpdXox&utm_source=qr",
      label: "Instagram",
    },
    {
      icon: Facebook,
      href: "https://www.facebook.com/share/1GSXrMQaHs/?mibextid=wwXIfr",
      label: "Facebook",
    },
    {
      icon: Linkedin,
      href: "https://www.linkedin.com/in/vinayak-enterprise-b53b2a409/?skipRedirect=true",
      label: "LinkedIn",
    },
  ];

  const handleSectionNavigation = (sectionId) => {
    navigateToSection({
      sectionId,
      pathname: location.pathname,
      navigate,
    });
  };

  return (
    <footer className="border-t border-[#2a3a5a] bg-[#0a1220] text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img
                src="/images/logo.jpeg"
                alt="Vinayak Enterprise industrial services logo"
                className="h-10 w-10 rounded object-cover"
                width="40"
                height="40"
                loading="lazy"
                decoding="async"
              />
              <h3 className="text-xl font-bold text-[#c23a4a]">Vinayak Enterprise</h3>
            </div>
            <p className="text-sm text-gray-400">
              Your trusted partner for business excellence. We deliver quality solutions tailored
              to your industrial and infrastructure requirements.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-semibold text-white">Quick Links</h4>
            <ul className="space-y-2">
              {sectionLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    onClick={(event) => {
                      event.preventDefault();
                      handleSectionNavigation(link.id);
                    }}
                    className="capitalize text-gray-400 transition-colors hover:text-[#c23a4a]"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-semibold text-white">Contact Us</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Email: vinayakenterprise137@gmail.com</li>
              <li>Phone: +91 98242 86872</li>
              <li>310, Samanvay Sequence, Manjalpur</li>
              <li>Vadodara, Gujarat - 390009</li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-semibold text-white">Follow Us</h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer me"
                  className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#2a3a5a] bg-[#1a2744] transition-colors hover:border-[#c23a4a] hover:bg-[#c23a4a]"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon size={20} className="text-white" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-[#2a3a5a] pt-8 text-center text-sm text-gray-400">
          <p>&copy; {currentYear} Vinayak Enterprise. All rights reserved.</p>
          <p className="mt-2">
            Website by{" "}
            <a
              href="https://ecliptixsolutions.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-medium text-[#c23a4a] transition-colors hover:text-[#e04a5a]"
            >
              Ecliptix Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
